if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

      this.addEventListener('product-info:loaded', ({ target }) => {
        target.addPreProcessCallback(this.preprocessHTML.bind(this));
      });
    }

hide(preventFocus = false) {
  const cartNotification =
    document.querySelector('cart-notification') ||
    document.querySelector('cart-drawer');

  if (cartNotification) cartNotification.setActiveElement(this.openedBy);

  const scrollY = this.stokkiScrollY || 0;
  const wasLocked = this.stokkiScrollLocked;

  /* REMOVE QUICK VIEW'S OWN MOBILE SCROLL LOCK */
  if (wasLocked) {
    const lockTargets = [
      this,
      this.querySelector('.quick-add-modal__content'),
      this.querySelector('.quick-add-modal__content-info'),
      this.querySelector('[role="dialog"]')
    ].filter(Boolean);

    lockTargets.forEach((element) => {
      element.style.removeProperty('overflow');
      element.style.removeProperty('overflow-y');
      element.style.removeProperty('overscroll-behavior');
      element.style.removeProperty('touch-action');
    });
  }

  this.modalContent.innerHTML = '';

  if (preventFocus) this.openedBy = null;

  super.hide();

  /* RESTORE PAGE AFTER QUICK VIEW CLOSES */
  if (wasLocked) {
    document.documentElement.style.touchAction = '';
    document.documentElement.style.overflow = '';

    document.body.style.touchAction = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';

    window.scrollTo(0, scrollY);

    this.stokkiScrollY = null;
    this.stokkiScrollLocked = false;
  }
}

show(opener) {
  opener.setAttribute('aria-disabled', true);
  opener.classList.add('loading');
  opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

  fetch(opener.getAttribute('data-product-url'))
    .then((response) => response.text())
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(
        responseText,
        'text/html'
      );

      const productElement = responseHTML.querySelector('product-info');

      this.preprocessHTML(productElement);

      HTMLUpdateUtility.setInnerHTML(
        this.modalContent,
        productElement.outerHTML
      );

      /* =========================================
         STOKKI MOBILE QUICK VIEW — FULL SCROLL LOCK
         IMPORTANT: RUNS BEFORE super.show()
         ========================================= */
      if (window.innerWidth <= 749) {
        this.stokkiScrollY = window.scrollY;
        this.stokkiScrollLocked = true;

        const lockTargets = [
          this,
          this.querySelector('.quick-add-modal__content'),
          this.querySelector('.quick-add-modal__content-info'),
          this.querySelector('[role="dialog"]')
        ].filter(Boolean);

        lockTargets.forEach((element) => {
          element.style.setProperty('overflow', 'hidden', 'important');
          element.style.setProperty('overflow-y', 'hidden', 'important');
          element.style.setProperty(
            'overscroll-behavior',
            'none',
            'important'
          );
          element.style.setProperty('touch-action', 'none', 'important');

          element.scrollTop = 0;
          element.scrollLeft = 0;
        });

        document.documentElement.style.touchAction = 'none';
        document.documentElement.style.overflow = 'hidden';

        document.body.style.touchAction = 'none';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.stokkiScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
      }

      super.show(opener);
    })
    .finally(() => {
      opener.removeAttribute('aria-disabled');
      opener.classList.remove('loading');
      opener
        .querySelector('.loading-overlay__spinner')
        .classList.add('hidden');
    });
}
    /*setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }*/

    preprocessHTML(productElement) {
      productElement.classList.forEach((classApplied) => {
        if (classApplied.startsWith('color-') || classApplied === 'gradient')
          this.modalContent.classList.add(classApplied);
      });
      this.preventDuplicatedIDs(productElement);
      this.removeDOMElements(productElement);
      this.removeGalleryListSemantic(productElement);
      this.updateImageSizes(productElement);
      this.preventVariantURLSwitching(productElement);
    }

    preventVariantURLSwitching(productElement) {
      /*const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');*/
      productElement.setAttribute('data-update-url', 'false');
    }

    removeDOMElements(productElement) {
      const pickupAvailability = productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs(productElement) {
      const sectionId = productElement.dataset.section;

      const oldId = sectionId;
      const newId = `quickadd-${sectionId}`;
      productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
      Array.from(productElement.attributes).forEach((attribute) => {
        if (attribute.value.includes(oldId)) {
          productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
        }
      });

      productElement.dataset.originalSection = sectionId;;
    }

    removeGalleryListSemantic(productElement) {
      const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes(productElement) {
      const product = productElement.querySelector('.product');
      const desktopColumns = product?.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 768px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
